import angular = require('angular');
import { LoadParams } from '../../../shared/models/loadparams.model';
import { ITarifaVT } from './models/tarifavt.model';

export class MeurhSolicitacoesalteracoesvtstarifasService {
    static $inject = ['$http', 'nsjRouting', '$rootScope', '$q'];

    public entities: Array<ITarifaVT> = [];
    public entity: ITarifaVT;
    public loaded: boolean = false;
    public constructors: any = {};
    public after: any = {};
    public filters: any = {};
    public loadParams: LoadParams;
    public loading_deferred: any = null;
    public filter: any = '';

    constructor(
        public $http: angular.IHttpService,
        public nsjRouting: any,
        public $rootScope: angular.IRootScopeService,
        public $q: angular.IQService
    ) {
        this.loadParams = new LoadParams();
    }

    reload(): Array<ITarifaVT> {
        if (this.loading_deferred) {
            this.loading_deferred.resolve();
        }

        this.loadParams.finished = false;
        this.loadParams.to_load = 3;
        this.after = {};
        this.loaded = false;
        this.entities.length = 0;
        this.loadParams.busy = false;

        return this.load();
    }

    search(filter?: any): Array<ITarifaVT> {
        if (typeof filter !== 'undefined') {
            this.filter = filter.search;

            Object.keys(this.filters).forEach((k): void => {
                delete this.filters[k];
            });

            for (let fil in filter.filters) {
                if (fil.indexOf('.') > -1) {
                    let filterSplit = fil.split('.');
                    this.filters[filterSplit[0]] = {};
                    this.filters[filterSplit[0]][filterSplit[1]] = filter.filters[fil];
                } else {
                    this.filters[fil] = filter.filters[fil];
                }
            }
        }

        return this.reload();
    }

    _load(constructors: any, offset: any, filter: any): angular.IHttpPromise<any> {
        this.loading_deferred = this.$q.defer();

        return this.$q((resolve: angular.IQResolveReject<any>, reject: angular.IQResolveReject<any>): void => {
            this.$http({
                method: 'GET',
                url: this.nsjRouting.generate('meurh_solicitacoesalteracoesvtstarifas_index', angular.extend({}, constructors, { 'offset': offset, 'filter': filter }, this.filters), true),
                timeout: this.loading_deferred.promise
            })
            .then((response: any): void => {
                resolve(response.data);
            })
            .catch((response: any): void => {
                reject(response);
            });
        });

    }

    load(): Array<ITarifaVT> {
        if (!this.loadParams.busy && !this.loadParams.finished && this.loadParams.to_load > 0) {
            this.loadParams.busy = true;

            this._load(this.constructors, this.after, this.filter)
                .then((data: any): void => {
                    if (data.length > 0) {
                        for (let i = 0; i < data.length; i++) {
                            this.entities.push(data[i]);
                        }
                    }

                    this.loadParams.finished = true;
                    this.$rootScope.$broadcast('meurh_solicitacoesalteracoesvtstarifas_list_finished', this.entities);

                    this.loaded = true;
                    this.loadParams.to_load--;
                })
                .catch((error: any): void => {
                    if (error.xhrStatus !== 'abort') {
                        this.loadParams.finished = true;
                    }
                })
                .finally((): void => {
                    if (this.loaded || this.loadParams.finished) {
                        this.loadParams.busy = false;
                    }
                });
        }

        return this.entities;
    }

    loadMore(): void {
        this.loadParams.to_load = 3;
        this.load();
    }

    find(identifier: string): ITarifaVT | null {
        for (let i in this.entities) {
            if (this.entities[i]['solicitacaoalteracaovttarifa'] === identifier) {
                return this.entities[i];
            }
        }

        return null;
    }

    delete($identifier: any, force: boolean = false): void {
        if (typeof ($identifier) === 'object') {
            $identifier = $identifier['solicitacaoalteracaovttarifa'];
        }

        if ($identifier) {
            if (force || confirm('Tem certeza que deseja deletar?')) {
                this.loading_deferred = this.$q.defer();
                this.$http.delete(
                    this.nsjRouting.generate('meurh_solicitacoesalteracoesvtstarifas_delete', angular.extend(this.constructors, { 'id': $identifier }), true),
                    { timeout: this.loading_deferred.promise }
                )
                .then((response: any): void => {
                    this.$rootScope.$broadcast('meurh_solicitacoesalteracoesvtstarifas_deleted', {
                        entity: this.entity,
                        response: response
                    });
                })
                .catch((response: any): void => {
                    this.$rootScope.$broadcast('meurh_solicitacoesalteracoesvtstarifas_delete_error', {
                        entity: this.entity,
                        response: response
                    });
                });
            }
        }
    }

    _save(entity: any, autosave: boolean): angular.IHttpPromise<any> {
        let method, url;

        if (entity['solicitacaoalteracaovttarifa']) {
            method = 'PUT';
            url = this.nsjRouting.generate('meurh_solicitacoesalteracoesvtstarifas_put', { solicitacaoalteracaovt: entity.solicitacaoalteracaovt, 'id': entity['solicitacaoalteracaovttarifa'] }, true);
        } else {
            method = 'POST';
            url = this.nsjRouting.generate('meurh_solicitacoesalteracoesvtstarifas_create', angular.extend(this.constructors), true);
        }

        if (!autosave) {
            autosave = false;
            entity['$$__submitting'] = true;
        }

        let data = angular.copy(entity);

        if (data.hasOwnProperty('$$__submitting')) {
            delete data['$$__submitting'];
        }

        this.loading_deferred = this.$q.defer();

        return this.$http({
            method: method,
            url: url,
            data: data,
            timeout: this.loading_deferred.promise
        })
        .finally((): void => {
            if (!autosave) {
                entity['$$__submitting'] = false;
            }
        });
    }

    save(entity: any, autosave: boolean = false): void {
        this._save(entity, autosave)
            .then((response: any): void => {
                if (response.data.solicitacaoalteracaovttarifa) {
                    entity['solicitacaoalteracaovttarifa'] = response.data.solicitacaoalteracaovttarifa;
                }

                entity['$$_saved'] = true;

                this.$rootScope.$broadcast('meurh_solicitacoesalteracoesvtstarifas_submitted', {
                    entity: entity,
                    response: response,
                    autosave: autosave
                });
            })
            .catch((response: any): void => {
                this.$rootScope.$broadcast('meurh_solicitacoesalteracoesvtstarifas_submit_error', {
                    entity: entity,
                    response: response,
                    autosave: autosave
                });
            });
    }

    get(solicitacaoalteracaovt: string, identifier: string): angular.IHttpPromise<any> {
        this.loading_deferred = this.$q.defer();

        return this.$q((resolve: angular.IQResolveReject<any>, reject: angular.IQResolveReject<any>): void => {
            this.$http.get(
                this.nsjRouting.generate('meurh_solicitacoesalteracoesvtstarifas_get', { 'solicitacaoalteracaovt': solicitacaoalteracaovt, 'id': identifier }, true),
                { timeout: this.loading_deferred.promise }
            )
            .then((response: any): void => {
                this.$rootScope.$broadcast('meurh_solicitacoesalteracoesvtstarifas_loaded', response.data);
                resolve(response.data);
            })
            .catch((response: any): void => {
                reject(response);
            });
        });
    }
}
